<template>
  <v-container class="fiscais-de-contratos">
    <v-card
      class="auth-content"
      tile
    >
      <PageTitle
        main="TcWeb"
        icon="mdi-pencil-box-outline"
        sub="Funções Específicas"
        home="/"
      />
      <page-cad />
    </v-card>
  </v-container>
</template>
<script>
import PageTitle from '@/components/template/PageTitle'
import PageCad from './../components/fiscais'
export default {
  name: 'FiscaisDeContrato',
  components: { PageTitle, PageCad }
}
</script>
